var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['lixsa-cancel-btn', { 'lixsa-cancel-btn--disabled': _vm.disabled }],attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"lixsa-cancel-btn__label"},[_vm._v(_vm._s(_vm.label || _vm.$t('common.cancel')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }